function relateGenerate(articlelist){
    let str = '';
    articlelist.forEach((el,index) => {
        let IMG;
        if(el.ImageM) {
            IMG = el.ImageM
        }else {
            index%2 === 0 ? IMG = 'https://imgcdn.cna.com.tw/www/WebPhotos/1024/20210705/800x600_467364346809.jpg' : IMG = 'https://imgcdn.cna.com.tw/www/WebPhotos/1024/20211028/800x600_184237258172.jpg'
        }

        str +='<div class="itemBox">'
            +'<a href="'+ el.PageUrl +'" target="_blank" rel="noopener noreferrer">'
            +'<h3>'+el.HeadLine+'</h3>'
            +'<div class="wrap">'
            +'<img src="'+IMG+'" alt="">'
            +'</div>'
            +'</a>'
            +'</div>'
    });

    return str;
}

export { relateGenerate };